import { render, staticRenderFns } from "./QuitScenePage.vue?vue&type=template&id=47caeb3e&scoped=true&"
import script from "./QuitScenePage.vue?vue&type=script&lang=js&"
export * from "./QuitScenePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47caeb3e",
  null
  
)

export default component.exports